// extracted by mini-css-extract-plugin
export default {"container":"searchbar_container__6gwIc"};